import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const DesktopContainer: StyleRule = () => ({
    padding: pxToRem(14),
});

export const SkeletonImageDesktop: StyleRule = () => ({
    padding: pxToRem(14),
});

export const SkeletonTitleFirstLineDesktop: StyleRule = () => ({
    padding: pxToRem(14),
});

export const SkeletonTitleSecondLineDesktop: StyleRule = () => ({
    padding: pxToRem(14),
});

export const SkeletonSubheadingFirstLineDesktop: StyleRule = () => ({
    padding: pxToRem(14),
});
